import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Privacy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h4" gutterBottom>
        Privacy Policy
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Last updated: {new Date().toLocaleDateString()}
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          1. Overview
        </Typography>
        <Typography paragraph>
          We value your privacy. This policy explains what information we collect, how we use it, and your choices.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Information We Collect
        </Typography>
        <Typography paragraph>
          We may collect account information, usage data, and data from linked social accounts as needed to provide the service.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. How We Use Information
        </Typography>
        <Typography paragraph>
          We use information to provide and improve the service, personalize your experience, ensure security, and comply with legal obligations.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Data Sharing and Transfers
        </Typography>
        <Typography paragraph>
          We do not sell your personal information. We may share data with service providers under strict confidentiality and security requirements.
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Data Retention
        </Typography>
        <Typography paragraph>
          We retain information for as long as necessary to provide the service and for legitimate business or legal purposes.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Your Rights
        </Typography>
        <Typography paragraph>
          Depending on your location, you may have rights to access, correct, delete, or restrict processing of your personal information.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7. Security
        </Typography>
        <Typography paragraph>
          We implement reasonable administrative, technical, and physical safeguards to protect your information.
        </Typography>

        <Typography variant="h6" gutterBottom>
          8. Children’s Privacy
        </Typography>
        <Typography paragraph>
          Our service is not directed to children under 13. We do not knowingly collect personal information from children.
        </Typography>

        <Typography variant="h6" gutterBottom>
          9. Changes to This Policy
        </Typography>
        <Typography paragraph>
          We may update this policy from time to time. Continued use indicates acceptance of the updated policy.
        </Typography>

        <Typography variant="h6" gutterBottom>
          10. Contact Us
        </Typography>
        <Typography paragraph>
          For questions about this Privacy Policy, contact us via the support channels provided in the app.
        </Typography>
      </Box>
    </Container>
  );
};

export default Privacy;
